<template>
    <button @click="solicitar()" type="button" class="btn btn-sm btn-info btn-block">
        <i class="fa fa-download"></i> SOLICITAR CONFIGURAÇÃO
    </button>
</template>
<script>
    import {Comandos} from "../../class/comandos";
    import {Bus} from '../../class/bus';
    export default {
        props: {
            id_rastreador: {
                "default": null
            }
        },
        methods: {
            async solicitar(){
                await Comandos.solicitarConfiguracao(this.id_rastreador);
                Bus.$emit('comandos');
            }
        }
    }
</script>
